import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth, isAdmin } from "./firebase";

export default function useAuth() {
  const [user, setUser] = useState(undefined); // undefined = loading, null = logged out
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => setUser(u || null));
    return () => unsub();
  }, []);
  return {
    user,
    loading: user === undefined,
    admin: isAdmin(user),
  };
}
